var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toCamel } from '~/utils/toCamelCase';
const updateDataKeys = (searchedClauses) => {
    return searchedClauses.map(searchedClause => {
        const c = {};
        for (const [index, val] of Object.entries(searchedClause.source)) {
            if (index.indexOf(' ') !== -1) {
                const newKey = index.toLowerCase().replace(/\s/g, '_');
                c[toCamel(newKey)] = val;
            }
            else {
                c[index] = val;
            }
        }
        const newClauseSource = c;
        return Object.assign(Object.assign({}, searchedClause), { source: newClauseSource });
    });
};
const searchClauses = (ws, searchFilters, pageNumber) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const payload = {
        searchText: searchFilters.searchText,
        pageSize: 100,
        pageNumber,
        includeExpired: !!((_a = searchFilters.advancedFilters) === null || _a === void 0 ? void 0 : _a.includeExpired),
    };
    if ((_b = searchFilters.advancedFilters) === null || _b === void 0 ? void 0 : _b.includeExpired) {
        delete searchFilters.advancedFilters.includeExpired;
    }
    if (searchFilters.advancedFilters) {
        payload.advancedFilters = searchFilters.advancedFilters;
    }
    const clauseResults = yield new Promise(resolve => {
        ws.send('request:/clause-search:post', payload, (data) => resolve(data));
    });
    if (clauseResults.statusCode === 200) {
        if (clauseResults.payload) {
            if (clauseResults.queryInfo) {
                return { clauses: updateDataKeys(clauseResults.payload), query: clauseResults.queryInfo };
            }
            throw Error('Clause Search Response missing Query Info');
        }
        throw Error('Clause Search Response missing Clauses');
    }
    throw Error(`Clause Search Response returned status code: ${clauseResults.statusCode}`);
});
export default searchClauses;
